module.exports = "mat-card {\n    margin-bottom: 20px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/modulos/bajada/bajada.component.css
// module id = ./src/app/modulos/bajada/bajada.component.css
// module chunks = main